/** 库存布料数量按「码」入账：米/公斤需换算 */

export const M_TO_YD = 1.09361
export const YD_TO_M = 1 / M_TO_YD

export function metersToYards(meters) {
  const m = Number(meters)
  if (!Number.isFinite(m)) return 0
  return Math.round(m * M_TO_YD * 10) / 10
}

export function yardsToMeters(yards) {
  const y = Number(yards)
  if (!Number.isFinite(y)) return 0
  return Math.round(y * YD_TO_M * 10) / 10
}

/** 订单单位为米时，现场分码按跑码机读数（码）录入 */
export function isMeterFabricUnit(unitName, unitCode) {
  const c = String(unitCode || '')
    .trim()
    .toLowerCase()
  if (c === 'm' || c === 'meter' || c === 'metre') return true
  const n = String(unitName || '').trim()
  return n === '米' || n.toLowerCase() === 'meter' || n.toLowerCase() === 'metre'
}

export function dispatchBranchInputUsesYards(unitName, unitCode) {
  return isMeterFabricUnit(unitName, unitCode)
}

/**
 * @param {number} quantity 用户输入数量
 * @param {string} unitCode 单位代码（小写），如 yd、m、kg
 * @param {number|null|undefined} fabricYardsPerKg 每公斤折合码数（仅 kg 需要）
 * @returns {{ yards: number|null, error: string|null }}
 */
export function toInventoryYards(quantity, unitCode, fabricYardsPerKg) {
  const q = Number(quantity)
  if (!Number.isFinite(q) || q <= 0) {
    return { yards: null, error: '数量无效' }
  }
  const c = String(unitCode || '')
    .trim()
    .toLowerCase()
  if (c === 'yd' || c === 'yard') {
    return { yards: q, error: null }
  }
  if (c === 'm') {
    return { yards: Math.round(q * M_TO_YD * 10) / 10, error: null }
  }
  if (c === 'kg') {
    const ypk = Number(fabricYardsPerKg)
    if (!fabricYardsPerKg || !Number.isFinite(ypk) || ypk <= 0) {
      return { yards: null, error: '公斤入账请填写「每公斤折合码数」' }
    }
    return { yards: Math.round(q * ypk * 10) / 10, error: null }
  }
  return { yards: null, error: '不支持的单位' }
}

export function findYardUnitId(units) {
  const list = units || []
  const u =
    list.find((x) => String(x.unit_code || '').toLowerCase() === 'yd') ||
    list.find((x) => String(x.unit_code || '').toLowerCase() === 'yard') ||
    list.find((x) => String(x.unit_name || '').trim() === '码')
  return u?.unit_id ?? null
}
